import { useApiQuery } from '../useApiQuery';
import { operationsClient, apiGet } from '@/lib/api';
import { schedulerEndpoints } from '@/lib/api/endpoints';
import { schedulerKeys } from '@/lib/queryKeys';
import type { SchedulerCrew } from '@/types/scheduler';

/**
 * Fetches the list of crews from the scheduler microservice.
 */
export function useSchedulerCrews() {
  return useApiQuery<SchedulerCrew[]>({
    queryKey: schedulerKeys.crews(),
    queryFn: () => apiGet<SchedulerCrew[]>(operationsClient, schedulerEndpoints.crews()),
    showErrorToast: false,
  });
}
